import React from 'react';
import './Contact.css';

const Contact = () => {
  return (
    <section id="contact">
      <h2 className="contact-heading">GET IN TOUCH</h2>

      <form
        className="contact-form"
        action="https://formspree.io/f/your-form-id" // ← replace with your Formspree ID
        method="POST"
      >
        <input type="text" name="name" placeholder="Your Name" required />
        <input type="email" name="email" placeholder="Your Email" required />
        <textarea name="message" rows="6" placeholder="Your Message" required />
        <button type="submit">Send Message</button>
      </form>

      <footer className="footer">
        <p>&copy; {new Date().getFullYear()} Aryan Thakur • All rights reserved</p>
        <div className="footer-links">
          <a href="mailto:rynthakur@gmail.com" target="_blank" rel="noreferrer">Email</a>
          <a href="https://www.linkedin.com/in/your-linkedin" target="_blank" rel="noreferrer">LinkedIn</a>
          <a href="https://github.com/RynThakur" target="_blank" rel="noreferrer">GitHub</a>
        </div>
      </footer>
    </section>
  );
};

export default Contact;
